import { Box } from '@mui/material';
import { SectionTitle, SectionContent } from './LeaseTextPrimitives';

/**
 * Clauses 19-21, the single canonical version rendered by all five lease views.
 */
export const BreachClauses = () => (
  <>
    {/* Section 19 */}
    <Box className="section">
      <SectionTitle>19. BREACH OF AGREEMENT &amp; COLLECTION</SectionTitle>
      <SectionContent>
        It is mutually agreed between the landlord and the tenant that if the tenant commits a breach of this lease agreement or the Residential Tenancies Act, the landlord may:
        <Box component="ol" sx={{ mt: 3, listStyleType: 'upper-alpha', pl: 4 }}>
          <li>Recover arrears of rent</li>
          <li>Recover damages resulting from the breach</li>
          <li>Recover compensation for the use of the occupation by the tenant should be held after the tenancy has expired or terminated</li>
          <li>Recover possession of the premises</li>
          <li>
            In the case of a substantial breach, terminate this lease agreement after giving a 14 day notice under section 29(1) of the Act
          </li>
          <li>
            Should the rent become overdue or the tenant damage the premises and the landlord sue for the same or for possession or non-payment of rent, the tenant shall pay for all court costs and all legal fees associated with such action on a client solicitor basis.
            In addition, the tenant hereby agrees to pay all costs associated with the landlord having to hire a collection agency to collect overdue or unpaid rent.
          </li>
        </Box>
      </SectionContent>
    </Box>

    {/* Section 20 */}
    <Box className="section">
      <SectionTitle>20. INDEMNITY</SectionTitle>
      <SectionContent>
        The tenant will indemnify and save harmless the landlord for, and in relation to any and all loss, damage or personal injury caused by or sustained by the tenant or the tenant's guests or invitees, through neglect, misuse, or carelessness and the tenant shall indemnify and save harmless the landlord and agents for and from all action, claims for damage or injury of any nature, kind and description whatsoever arising out of or in connection with the tenant's occupation of the leased premises, the facilities, parking areas and grounds located in, upon or associated with the leased premises, and the tenant acknowledges that the landlord shall not be responsible for ant loss of the tenant's property, however caused and that the tenant is responsible for insuring his property against loss from any cause.
      </SectionContent>
    </Box>

    {/* Section 21 */}
    <Box className="section">
      <SectionTitle>21. RULES AND REGULATIONS</SectionTitle>
      <SectionContent>
        The parties hereto mutually covenant and agree that the landlord may from time to time make such responsible rules and regulations for the care, use and cleanliness of the leased premises, the parking areas, the grounds and facilitation, upon or about the building in which the leased premises are located. The tenant hereby covenants to obey such rules and regulations and agrees that any amendments to the rules and regulations for the care of this lease shall be deemed to be made a binding and form part of this lease.
        <br />
        <Box component="ol" sx={{ mt: 3, listStyleType: 'upper-alpha', pl: 4 }}>
          <li>
            Nothing shall be thrown or placed or hung outside the windows or on window ledges without written permission.
            This specifically includes but is not limited to satellite dishes. Any junk removal items such as Mattresses, Appliances or other items left in garbage dump or surrounding area of the property, tenant will be charged <b>$200</b> per item for removal.
            Air conditioners are not allowed on the window unless its portable unit approved by Management.
          </li>
          <li>
            The tenant further hereby agrees not to place any curtains or drapes on the windows and specifically not to use sheets, blankets, tin foil, or flags to cover windows. In the event the landlord finds such items being used and the tenant does not remove them, the tenant agrees to compensate the landlord <b>$150</b> for his time and trouble of removing such window coverings and trouble of sourcing and placing appropriate window coverings in the windows.
          </li>
          <li>
            Balcony decks shall be for the use of barbecues (up to 20 pounds tanks only) and plants and shall not be used for storage areas. Boxes, tires or other articles may not be placed on the balcony or rails.
          </li>
          <li>
            The tenant agrees to remove any soiled or wet footwear in the lobby of the building in which the premises is located and carry the footwear to his suite.
          </li>
          <li>
            No structural alterations, wall mount TV, painting, wallpaper, decals, re-decorating or driving of nails, screws in walls, floors or woodwork are to be done without written consent.
          </li>
          <li>
            No rubbish or boxes shall be left in the corridors, parking areas or entrance and deck areas or around garbage disposal containers.
            Furniture, large appliances and other items, which will not fit in the dumpster, must be carted to the dump by the tenant for removal of such items.
          </li>
          <li>
            Windows shall not be left open to cause damage by rain, water or freezing to the premises at any time.
            The tenant shall be responsible for any damage caused by such an action.
            Smoking any material such as Cannabis, Tobacco, Cigar material, Vaping (or Marijuana of any form) is <b>NOT</b> allowed in suites, patios, green spaces, parking lot, Inside/Outside premises of the property, Underground Parking or Yard.
            No Cannabis plants to be grown on property also.
          </li>
          <li>
            If negligence caused by the tenant for broken or damaged glass, locks or trimmings on doors or windows of the premises, tenant must pay for damages. No Real Trees for Christmas Trees allowed.
          </li>
          <li>
            If the tenant is absent for an extended period or the premises is unoccupied, the tenant is to arrange for a regular inspection by a competent person or let the management know.
          </li>
          <li>
            The fan for HRV needs to be kept on reduced mode during whole term of tenancy. This is to have proper circulation of air in house and to prevent any damage caused by attic rain.
          </li>
        </Box>
      </SectionContent>
    </Box>
  </>
);

export default BreachClauses;
